import {
  Banknote,
  Boxes,
  ChartColumn,
  CloudOff,
  Fuel,
  Package,
  ReceiptText,
  ScrollText,
  Settings,
  ShoppingCart,
  Smartphone,
  Tags,
  Users,
} from "lucide-react";
import type { ReactNode } from "react";
import type { NavKey } from "../domain/access";

export const NAV_ICON: Record<NavKey, ReactNode> = {
  checkout: <ShoppingCart />,
  till: <Banknote />,
  sales: <ReceiptText />,
  products: <Package />,
  categories: <Tags />,
  inventory: <Boxes />,
  fuel: <Fuel />,
  customers: <Users />,
  mpesa: <Smartphone />,
  reports: <ChartColumn />,
  settings: <Settings />,
  audit: <ScrollText />,
  queue: <CloudOff />,
};
